import React from 'react';

// Spectrum Components
import Heading from '@react/react-spectrum/Heading';

// I18n
import { Translate, I18n } from 'react-redux-i18n';
import Button from '@react/react-spectrum/Button';
// Project Components
import Progress from '../global/Progress';


class ThankYouCorporate extends React.Component {
  onCBCclick = () => {
    const url = I18n.t('workflow.error_page.cbc_link');
    window.open(url, '_self');
  };

  onAPCclick = () => {
    const url = I18n.t('workflow.error_page.apc_direct_login');
    window.open(url, '_self');
  };

  render() {
    return (
      <div data-testid="thank-you-corporate">
        <Progress step={4} />
        <div className="page-container">
          <Heading>
            <Translate data-testid="thank-you-header" value="workflow.thank_you_page.header" />
          </Heading>
          <div>
            <p><Translate data-testid="thank-you-text" value="workflow.thank_you_page.thank_you_corporate" /></p>
            <p>
              <Translate data-testid="questions-contact-helpdesk" value="workflow.thank_you_page.questions_contact_helpdesk" />
            </p>
          </div>
          <div className="button-container">
            <Button data-testid="cbc-button" variant="cta" onClick={this.onCBCclick}><Translate value="workflow.error_page.cbc_button_text" /></Button>
            <Button data-testid="apc-button" variant="cta" onClick={this.onAPCclick}><Translate value="workflow.error_page.apc_button_text" /></Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ThankYouCorporate;
